// extracted by mini-css-extract-plugin
module.exports = {"inventoryListTemplate":"AdsetTransferOfInventory_inventoryListTemplate_3_O7u","inventoryFormat":"AdsetTransferOfInventory_inventoryFormat_-QQYM"};